import React from "react";
import { useNavigate } from "react-router-dom";
import { Plus } from "lucide-react";
import "./NavigationButtons.css";

const CreateContentButton = ({ title = "Create Content", disabled = false }) => {
  const navigate = useNavigate();

  const handleClick = (e) => {
    if (disabled) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }
    navigate("/create-content");
  };

  return (
    <button
      className="nav-button nav-button-create"
      onClick={disabled ? undefined : handleClick}
      title={title}
      disabled={disabled}
    >
      <Plus size={18} strokeWidth={2} />
    </button>
  );
};

export default CreateContentButton;
